// extracted by mini-css-extract-plugin
export default {"section":"Uq-z","sectionTitle":"Vq-z","fieldWrapper":"Wq-z","formField":"Xq-z","disabled":"Yq-z","formLabel":"Zq-z"};